// Vendor JS
import Debug from 'debug';

// Custom JS
import { getClosest } from '../util/dom';
import addScript from '../util/load-script';

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-template */
/* eslint-disable func-names */

class Portfolios {
	/**
	 * Add or attempt to add the simple-datatables script, then instantiate the portfolios class
	 */
	init = () => {
		try {
			Debug(`cig:info:sage:class:Portfolios`)(`init start`);

			addScript(`simple-datatables`, `https://cdn.jsdelivr.net/npm/simple-datatables@latest`, () => this.setup());
		} catch (err) {
			Debug(`cig:error:sage:class:Portfolios`)(`Portfolios init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Setup all the portfolio filtering etc.
	 */
	setup = () => {
		try {
			Debug(`cig:info:sage:class:Portfolios`)(`setup start`);

			/**
			 * Table Sorting
			 */
			const TableSorter = {
				makeSortable(table) {

					// variables, store context of this/TableSorter in object
					const _this = this;
					let th = table.tHead;
					let i;

					// if th exists and there's a row for it, grab the cells of the row
					if (th) {
						th = th.rows[0] ? th.rows[0].cells : null;
					}

					if (th) {
						i = th.length;
					} else {
						return;
					}

					// loop through every <th> inside the header
					while (--i >= 0) {
						(function (i) {
							let direction = 1;

							// append click listener to sort
							th[i].addEventListener('click', (e) => {
								// prevent link click
								e.preventDefault();

								// Make sure the TH is what's being used rather than a nested span
								const eventTH = (e.target.tagName === 'SPAN') ? e.target.parentNode : e.target;

								// Get current sort order if exists. We'll set clicked column to opposite so default should be the opposite of what you want
								const currentSort = eventTH.classList.contains('sort_asc') ? 'asc' : 'desc';

								// Remove current sort classes on all th elements
								table.tHead.querySelectorAll(`th.sort_asc, th.sort_desc`)
									.forEach(el => {
										el.classList.remove('sort_asc');
										el.classList.remove('sort_desc');
									});

								// Make sure the event target is not the span and is the th
								// Set the sort class asc/desc depending on current sort logic above
								if (currentSort === 'asc') {
									eventTH.classList.add('sort_desc');
								} else {
									eventTH.classList.add('sort_asc');
								}

								// Fire sort
								_this.sortTable(table, i, (direction = 1 - direction));
							});
						}(i));
					}
				},

				// Reorganize the table. NOTE: since entry dates written mm/dd/yy this is currently sorting by month
				sortTable: (table, col, reverse) => {
					const tb = table.tBodies[0]; // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
					let tr = Array.prototype.slice.call(tb.rows, 0); // put rows into array

					// flip switch
					const reverseReverse = -((+reverse) || -1);

					// sort rows, `-1 *` for opposite order
					tr = tr.sort((a, b) => {

						let sortValue = 1;
						a = a.cells[col].textContent.trim();
						b = b.cells[col].textContent.trim();

						// Make sure that monetary values are sorted properly
						if (a.startsWith(`$`) || b.startsWith(`$`)) {
							// Remove $ from the beginning as well as commas from strings and convert to a numeric values
							a = Number(a.replace(/(^\$|,)/g, ''));
							b = Number(b.replace(/(^\$|,)/g, ''));
						}

						// Numeric sort
						if (!isNaN(a) && !isNaN(b)) {
							sortValue = (+a > +b) ? reverseReverse : -1;

						// Date sort
						} else if (!isNaN(new Date(a)) && !isNaN(new Date(b))) {
							sortValue = (Date.parse(a) > Date.parse(b)) ? reverseReverse : -1;

						// Alpha sort
						} else {
							sortValue = reverseReverse * (
								// sorting by comparing cell content
								a.localeCompare(b)
							);
						}

						return sortValue;
					});

					for (let i = 0; i < tr.length; ++i) {
						// append rows in new order
						tb.appendChild(tr[i]);
					}
				}
			};

			/**
			 * Simple Portfolio Tables
			 */
			document.querySelectorAll(`.portfolio.table`).forEach(elPortfolio => {
				const tableId = elPortfolio.id;

				// replace this instantiation with one referencing the window object property the script will be assigned to ?
				// The script will be added and executes immediately, not sure if this will be able to access it or not.
				const { DataTable } = window.simpleDatatables;

				const dataTable = new DataTable(elPortfolio, {
					paging: false,
					searchable: true,
					sortable: false // plugin sort method is deprecated, just adding this param to clean up the classes
				});

				dataTable.on('datatable.init', args => {

					// sort method call
					TableSorter.makeSortable(elPortfolio);

					const elDataTableWrapper = getClosest(elPortfolio, '.datatable-wrapper');

					const elDataTableTop = elDataTableWrapper.querySelector('.datatable-top');

					const elDataTableBtns = document.createElement('div');

					elDataTableBtns.classList.add('datatable-buttons');

					// CSV btn
					const btnCsv = document.createElement('button');

					btnCsv.setAttribute('class', 'btn btn-large btn-info btn-csv');
					btnCsv.innerText = "CSV";

					// TODO: delete if meta-wrapper works
					elDataTableBtns.appendChild(btnCsv);

					// export current page as csv
					btnCsv.addEventListener('click', () => {
						exportTableToCSV(tableId);
					});

					// PRINT btn
					const btnPrint = document.createElement('button');

					// TODO: update
					btnPrint.setAttribute('class', 'btn btn-large btn-info btn-print');
					btnPrint.innerText = "Print";

					// TODO: delete if meta-wrapper works
					elDataTableBtns.appendChild(btnPrint);

					// print current page/table
					btnPrint.addEventListener('click', () => {
						dataTable.print();
					});

					elDataTableTop.prepend(elDataTableBtns);

					/** TODO: there is an issue with Windows (IE, Chrome, FF) and Android (Chrome) where the file extension '.csv' is not appended to the filename
					 * Download Portfolio as a CSV
					 *
					 * @param {string } csv String of comma separated values
					 * @param {string} filename The table tag's id attribute ie. "portfolio-growth", used as the CSV's filename portfolio-growth.csv
					 */
					const downloadCSV = (csv, filename) => {
						// CSV file - pass MIME type of 'text/csv' to ensure the browser knows the file type
						const csvFile = new Blob([csv], { type: 'text/csv' });

						// <a> link
						const downloadLink = document.createElement('a');

						// assigning file name to download
						downloadLink.download = filename;

						// create a link for file
						downloadLink.href = window.URL.createObjectURL(csvFile);

						// hide link
						downloadLink.style.display = "none";

						// make link
						document.body.appendChild(downloadLink);

						// Click download link — only simulates click? unsure why this is needed
						downloadLink.click();
					};

					/**
					 * Extract table data from HTML, build a string of comma separated values and pipe them into downloadCSV()
					 *
					 * @param {string} filename The table tag's id attribute ie. "portfolio-growth", used as the CSV's filename portfolio-growth.csv
					 */
					const exportTableToCSV = (filename) => {
						const csv = [];
						const table = document.getElementById(filename);
						const rows = table.querySelectorAll("tr");

						for (let i = 0; i < rows.length; i++) {
							const row = [];
							const cols = rows[i].querySelectorAll("td, th");

							for (let j = 0; j < cols.length; j++) {
								row.push(`"${cols[j].innerText}"`);
							}

							csv.push(row.join(","));
						}

						// download CSV file
						downloadCSV(csv.join("\n"), filename);
					};
				});
			});

			/**
			 * Click handler for Jump to Year dropdown on Closed/Transactions portfolios
			 */
			const transactionsPortfolioJumpToYearHandler = event => {
				// Attempt to set the dropdown assuming the Jump to Year button was the target
				let dropdown = event.target.parentElement.querySelector(`ul[role="menu"].dropdown-menu`);

				// If the Jump to Year button was not the target, then it was one of the dropdown's links
				if (!dropdown) {
					dropdown = event.target.closest(`ul[role="menu"].dropdown-menu`);
				}

				// If already shown, hide menu
				if (dropdown.classList.contains(`show`)) {
					dropdown.classList.remove(`show`);
				} else {
					// Show Menu
					dropdown.classList.add(`show`);
				}
			};

			/**
			 * Add Closed/Transactions Jump to Year Handler
			 */
			const addTransactionsJumpToYearButtonHandlers = () => {
				const buttons = document.querySelectorAll('.portfolio-transactions-container > .btn-group > button[type="button"]');

				buttons.forEach(button => {
					button.addEventListener('click', transactionsPortfolioJumpToYearHandler);

					// Get all links in the dropdown
					const links = button.parentElement.querySelectorAll(`ul.dropdown-menu > li > a`);

					links.forEach(link => {
						link.addEventListener(`click`, transactionsPortfolioJumpToYearHandler);
					});
				});
			};

			/**
			 * Jim Fink's Options Tables
			 */
			if (document.querySelector('table.options-portfolio')) {
				// TODO: add back
				// $("table.options-portfolio").fixMe(); // TODO: fixMe is commented out below
			}

			/**
			 * Options Portfolio Date/Alpha Sort
			 *
			 * @param event
			 */
			const optionsPortfolioDateAlphaSortButtonHandler = event => {
				// Set Sort type
				const sort = event.target.closest('label.btn').getAttribute('data-sort');

				// Create url object using current url
				const url = new URL(window.location);

				// If query params exist update; otherwise add to (existing) query string
				url.searchParams.set('sort', sort);

				// Reload the window with updated query string
				window.location = url.toString();
			};

			/**
			 * Add event Handlers for Options Portfolio Filters and Sorting Buttons
			 */
			const addOptionsPortfolioSortButtonHandlers = () => {
				// TODO: is this check needed (was used in jQuery
				if (document.querySelector('table.options-portfolio')) {
					const dateAlphaButtons = document.querySelectorAll('.options-sort > .btn');

					dateAlphaButtons.forEach((button) => {
						button.addEventListener('click', optionsPortfolioDateAlphaSortButtonHandler);
					});
				}
			};

			/**
			 * Options Portfolio Open/Closed Filter
			 *
			 * @param event
			 */
			const optionsPortfolioOpenClosedFilterButtonHandler = event => {
				// Set Filter type
				const filter = event.target.closest('label.btn').getAttribute('data-filter');

				// Create url object using current url
				const url = new URL(window.location);

				// If query params exist update them; otherwise add them to (existing) query string
				url.searchParams.set('active', +(filter !== 'closed')); // if not closed will be an integer value of 1
				url.searchParams.set('expired', +(filter === 'closed')); // if closed will be an integer value of 1

				// Reload the window with updated query string
				window.location = url.toString();
			};

			/**
			 * Add event Handlers for Options Portfolio Filters and Sorting Buttons
			 */
			const addOptionsPortfolioFilterButtonHandlers = () => {
				const openClosedButtons = document.querySelectorAll('.options-filter > .btn');

				openClosedButtons.forEach((button) => {
					button.addEventListener('click', optionsPortfolioOpenClosedFilterButtonHandler);
				});
			};

			/**
			 * Click handler for print button on /portfolio
			 */
			const optionsPortfolioPrintHandler = event => {
				// Create url object using current url
				const url = new URL(window.location);

				// add '/print/' to the end of the url and remove hashes as well as trailing slash of pathname
				const printUrl = url.protocol + '//' + url.host + url.pathname.replace(/\/$/, "") + /print/ + url.search;

				// Open new tab and print dialog
				window.open(printUrl).print();
			};

			/**
			 * Add Portfolio Options Print button handler(s)
			 */
			const addOptionsPortfolioPrintButtonHandlers = () => {
				const optionsPrintButtons = document.querySelectorAll('#optionsPrint');

				optionsPrintButtons.forEach(options => {
					options.addEventListener('click', optionsPortfolioPrintHandler);
				});
			};

			// call when script loads
			addOptionsPortfolioPrintButtonHandlers();
			addOptionsPortfolioFilterButtonHandlers();
			addOptionsPortfolioSortButtonHandlers();
			addTransactionsJumpToYearButtonHandlers();

		} catch (err) {
			Debug(`cig:error:sage:class:Portfolios`)(`Portfolios setup Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
}

export default new Portfolios();
